<template>
  <div id="login" class="login-wrap">
    <div class="login-form-box">
      <el-form ref="form" :model="form">
        <el-form-item>
          <span>用户登录</span>
        </el-form-item>
        <el-form-item label="部门选择：">
          <el-select
            v-model="form.department"
            placeholder="请选择部门"
            style="width:300px;"
            @change="getPerson"
          >
            <el-option
              v-for="item in base_info.depart_list"
              :key="item.depart_id"
              :label="item.depart_name"
              :value="item.depart_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名：">
          <el-select v-model="form.user" placeholder="请选择用户名" style="width:300px;margin-left:15px">
            <el-option
              v-for="item in getPersonData"
              :key="item.employee_id"
              :label="item.employee_name"
              :value="item.employee_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密码输入：">
          <el-input
            placeholder="请输入密码"
            v-model="form.password"
            show-password
            type="password"
            style="width:300px"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <el-checkbox-group class="remember" v-model="form.check">
            <el-checkbox :checked="true" label="记住密码" name="check"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>-->
        <el-form-item style="float:right">
          <el-button type="primary" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { login, getBaseInfo, getPerson } from "@/api/user";
export default {
  name: "login",
  data() {
    return {
      base_info: {},
      getPersonData: {},
      form: {
        department: "",
        user: "",
        password: "",
        check: [true]
      }
    };
  },
  created() {
    this.getData();
    this.getuserInfo();
  },

  methods: {
    getuserInfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      if (!uesrInfo && typeof uesrInfo != "undefined" && uesrInfo != 0) {
      } else {
        //console.log((uesrInfo));
        this.form.department = uesrInfo.depart_ID;
        // this.getData();
        this.getPerson(this.form.department);
        this.form.user = uesrInfo.employee_id;
        this.form.password = uesrInfo.password;
      }
    },

    // 当记住密码的checbox选中时，像localStorage里存入一下用户输入的用户名和密码
    // submitForm(formName) {
    //   const self = this
    //   if (self.checked == true) {
    //     self.setlocalStorage(self.ruleForm.username, self.ruleForm.password)
    //   } else {
    //     self.clearlocalStorage()
    //   }
    //   //与后端请求代码，暂时还没有请求地址，先省略了
    //   console.log('登陆成功')
    // },

    //跳转路由并传递部门ID
    login() {
      if (
        this.form.department == "" ||
        this.form.user == "" ||
        this.form.password == ""
      ) {
        alert("请先选择部门和用户名并输入密码！");
      } else {
        var sendLoginMsg = {
          employee_id: this.form.user,
          password: this.form.password
        };
        login(sendLoginMsg).then(res => {
          //console.log(res)
          if (0 != status) {
            alert("请求超时");
          } else {
            if (res.data.errcode != 0) {
              alert("密码错误");
            } else {
              this.qxianlist = res.data.permission_list;
              //console.log(this.qxianlist);
              const roles = this.qxianlist;
              var info = {
                employee_id: this.form.user,
                password: this.form.password,
                qxianlist: this.qxianlist,
                depart_ID: this.form.department
              };
              //console.log(this.form.user);

              localStorage.setItem("uesrInfo", JSON.stringify(info));

              this.$root.Time = moment(new Date()).format("YYYY-MM-DD");
              //localStorage.removeItem("timeAndDepart");
              let timeAndDepart = {};
              localStorage.setItem("timeAndDepart",JSON.stringify(timeAndDepart));
              localStorage.removeItem("zhou");
              localStorage.removeItem("xiangmu");
              //console.log(this.$root.Time);

              this.$router.push({
                path: "/Preson"
              });
            }
          }
        });
      }
    },
    //获取部门数据
    getData() {
      
      getBaseInfo().then(data => {
        //console.log(data);
        this.base_info = data;
      });
    },
    //获取人员数据
    getPerson(grValue) {
      if (grValue == "") {
        var bumenID = this.form.department;
      } else {
        var bumenID = grValue;
        //console.log(grValue)
      }
      //console.log(this.form.department);
      if (this.form.department != "") {
        this.form.user = "";
        getPerson(bumenID).then(data => {
          //console.log(data)
          this.getPersonData = data.employee_list;
        });
      } else {
        alert("请先选择部门！");
      }
    }
  }
};
</script>

<style scoped lang="less">
.login-form-box {
  height: 280px;
  width: 400px;
  padding: 30px;
  background-color: white;
  box-shadow: 0 0 6px 5px #dcdcdc;
  border-radius: 4px;
  position: absolute;
  left: 45%;
  top: 40%;
  margin-left: -200px;
  margin-top: -140px;
  span {
    font-family: Arial;
    font-weight: bold;
  }
}
.password-item {
  margin-bottom: 5px;
}
.remember {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue